<template>
  <div>
    <div class="container-fluid mobile-margin">
      <div class="row">
        <div class="card border-0" style="background:#ffffff00; border-radius: 15px;">
          <div class="card-body card-background">
            <div class="row" style="min-width:50px; top:0%;">
              <div class="col-12 text-start align-middle">
                <span style="font-size:16px; color:white;" class="text-stroke">Policy Acceptance Report</span>
              </div>
            </div>

            <div class="row">

              <div class="col text-center mx-auto" v-if="loading">
                <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
                <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
              </div>

              <table class="table mt-4 table-responsive" v-else>
                <thead class="align-middle">
                  <tr>
                     <th scope="col" v-for="header in headers" :key="header.value" :class="header.width">{{ header.text }}
                     </th>
                  </tr>
               </thead>

               <tbody v-if="this.pagination.totalItems <= 0">
                  <tr>
                     <td colspan="4">
                        No records to display.
                     </td>
                  </tr>
               </tbody>


               <tbody>
                  <tr v-for="(item) in items" :key="item.id">
                     <td >{{ item.user_name }}</td>
                     <td >{{ item.user_email }}</td>
                     <td >{{ item.training_topic }}</td>
                     <td>{{ item.version == 0 ? '-' : item.version }}</td>
                     <!-- <td class>{{ $helper.truncateLongText(item.policy_link, 35)  }}
                      <button @click="copyToClipboard(item)" class="btn btn-link copy-button">
                          <i class="fas fa-copy" style="color: #435666;"></i>
                      </button>
                    </td> -->
                     <td class="small">{{ localFormat(item.date_accepted) }}</td>
                  </tr>
                </tbody>

              </table>

            </div>



            <!-- START -- PAGINATION -->

            <div class="d-flex align-items-center justify-content-between text-default d-none d-md-flex d-sm-flex">

              <div class="d-flex p-1">
              <button :disabled="downloading" type="button" class="btn btn-labeled default btn-sm" v-tooltip.top="'Download Policy Acceptance Report'" :class="{ 'text-small': vssWidth <= 1065  }"   @mouseover="btnDownload = 'white'" @mouseleave="btnDownload= '#00A0C1'" @click="downloadCSV">
                <div v-if="downloading" class="spinner-border" role="status" style="height:15px; width:15px;">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span class="btn-label" v-if="!downloading">
                <svg width="17" :height="vssWidth <= 1065 ? 14 : 16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.35682 11.3864C8.37383 11.4081 8.39556 11.4257 8.42036 11.4378C8.44517 11.4498 8.4724 11.4561 8.5 11.4561C8.5276 11.4561 8.55483 11.4498 8.57964 11.4378C8.60444 11.4257 8.62617 11.4081 8.64318 11.3864L11.1886 8.16591C11.2818 8.04773 11.1977 7.87273 11.0455 7.87273H9.36136V0.181818C9.36136 0.0818182 9.27955 0 9.17955 0H7.81591C7.71591 0 7.63409 0.0818182 7.63409 0.181818V7.87045H5.95455C5.80227 7.87045 5.71818 8.04546 5.81136 8.16364L8.35682 11.3864ZM16.8182 10.5909H15.4545C15.3545 10.5909 15.2727 10.6727 15.2727 10.7727V14.2727H1.72727V10.7727C1.72727 10.6727 1.64545 10.5909 1.54545 10.5909H0.181818C0.0818182 10.5909 0 10.6727 0 10.7727V15.2727C0 15.675 0.325 16 0.727273 16H16.2727C16.675 16 17 15.675 17 15.2727V10.7727C17 10.6727 16.9182 10.5909 16.8182 10.5909Z" :fill="btnDownload"/>
                </svg></span> <span class="d-none d-sm-inline">Download Report (.xlsx)</span>
              </button>

              </div>

              <div class="d-flex align-items-center justify-content-end text-default d-none d-md-flex d-sm-flex">
                <div style="display: flex; align-items: center;">
                  <span style="margin-right: 8px; font-size: 14px;">Rows per page:</span>

                  <select
                    class="form-select form-select-sm shadow-none rounded-0"
                    v-model="this.pagination.pageSize"
                    style="width: 5rem;"
                  >
                  <option class="dropdown-item" v-for="(item, index) in rowsOptions" :key="index" >
                    {{item}}
                  </option>
                  </select>
                </div>
                <div style="padding-right: 16px; padding-left: 16px; font-size:14px;">
                  <span> {{ paginationLabel }} of {{ this.pagination.totalItems }} </span>
                </div>
                <div class="d-inline pagination">
                    <a @click="previousPage()" style="margin-right: 8px;"
                        :style="this.pagination.page == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                        :disabled="this.pagination.page == 1">
                        <i class="fa fa-chevron-left"></i>
                    </a>
                    <a @click="nextPage()" style="margin-left: 8px;" :style="this.pagination.page == this.pagination.totalPages
                        || this.pagination.totalItems == 0 ? 'color: #ccc;' : 'cursor: pointer;'"
                        :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0">
                        <i class="fa fa-chevron-right"></i>
                    </a>
                  </div>


              </div>

            </div>
            <!-- START -- PAGINATION -->

          </div>
        </div>
      </div>
       </div>
   </div>
 </template>

 <script>
import moment from 'moment';
import * as XLSX from 'xlsx'

  export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],

     data() {
        return {
          loading: false,
          btnDownload: "#00A0C1",
          downloading: false,
          headers: [
            { text: "User", value: "user", width: "col-2" },
            { text: "Email", value: "email", width: "col" },
            { text: "Policy Name", value: "policyName", width: "col" },
            { text: "Version", value: "version", width: "col" },
            // { text: "Policy Link", value: "policyLink", width: "col" },
            { text: "Date/Time of Acceptance", value: "date_time", width: "col" },
         ],
          items:[],
          pagination: {
            pageSize: 5,
            page: 1,
            totalItems: 0,
            totalPages: 1,
          },
          rowsOptions: [5,10,15],
          vssWidth: 3000,
      }
    },

    async created() {
      if (!this.showProduct) return
      await this.init()
    },

    methods: {
      async init(){
        this.items = [];
        this.loading = true;

        this.getData()
      },

      getData(){
        let params = {
          limit: this.pagination.pageSize,
          page: this.pagination.page
        }

        if (this.isManager)  params.manager = this.isManager;

        return new Promise((resolve, reject) => {
        this.$axios.get("/orgadmin/trainings/organisations/"+this.organisationID + "/training-policy/table", {params})
        .then(response => {
          if (response.data.success) {
            this.pagination.totalItems = response.data.total
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
            this.items = response.data.policies

            this.loading = false
            resolve()
          }
        }).catch(error => {
            this.loading = false
            reject(error)
          })
        })
     },

     async downloadCSV() {
      this.downloading = true;

      if (this.items.length == 0) {
        this.$toast.error('No Policy Acceptance Report to download.')
        this.downloading = false;
        return
      }

      if (this.downloadingSummary)
        return

      let params = {
        limit: -1
      };

      if (this.isManager)  params.manager = this.isManager;

      try {
        let response = await this.$axios.get("/orgadmin/trainings/organisations/" + this.organisationID + "/training-policy/table-download", { params });
        if (response.data.success) {
          let policies = response.data.policies;

          // Prepare data for CSV
          let csvData = this.prepareCSVData(policies);
          this.generateCSV(csvData);

          this.downloading = false;
        }
      } catch (error) {
        console.error("Error downloading CSV:", error);
        this.downloading = false;
      }
    },

    prepareCSVData(policies) {
      let headers = ["User Name", "User Email", "Policy Name", "Version", "Date Accepted"];
      let csvContent = [headers];

      policies.forEach(policy => {
        csvContent.push([
          policy.user_name,
          policy.user_email,
          policy.training_topic,
          policy.version,
          this.localFormat(policy.date_accepted)
        ]);
      });

      return csvContent;
    },

    generateCSV(csvData) {
      const ws = XLSX.utils.aoa_to_sheet(csvData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Policy Breakdown");
      const dateToday = moment().format("YYYYMMDD");
      const fileName = dateToday + "_" + this.formattedOrgName + "_Policy Acceptance Report.xlsx";

      XLSX.writeFile(wb, fileName);
    },

    previousPage() {
      this.pagination.page > 1 ? this.pagination.page -= 1 : ''
    },

    nextPage() {
      this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
    },

    localFormat(date){
      return moment(date).local().format("LLL");
    },

    copyToClipboard(item) {

        const tempInput = document.createElement('input');
        tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
        tempInput.value = item.policy_link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        if (item.pdf_exists)
          this.$toast.success("Copied link to clipboard.");
        else
          this.$toast.warning("Copied link to clipboard. PDF Policy being replaced");

    },

  },

  computed: {
    paginationLabel() {
      var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
      var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)

      return start + " - " + end
    },

    currentPage() {
      return this.pagination.page
    },

    rowsPerPage() {
      return this.pagination.pageSize
    },

    pageSize() {
      return this.pagination.pageSize
    },

    orgName(){
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation
    },

    formattedOrgName() {
      if (this.orgName) {
        if (this.orgName.includes(" ")) {
          // If orgName contains spaces, replace them with underscores
          return this.orgName.replace(/ /g, "_");
        } else {
          // If orgName doesn't contain spaces, keep it as is
          return this.orgName;
        }
      }
      return "";
    },
  },

  watch: {
    currentPage() {
      this.init()
    },

    pageSize() {
      this.pagination.page = 1
      this.init()
    },
  }

  }

 </script>
 <style scoped>
 .card-background {
   border-radius: 15px;
   background: #ffffff;
   overflow: auto;

   background: #00a0c1; /* Old browsers */
     background: -moz-linear-gradient(top,  #00a0c1 0%, #00a0c1 50px, #ffffff 50px); /* FF3.6-15 */
     background: -webkit-linear-gradient(top,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* Chrome10-25,Safari5.1-6 */
     background: linear-gradient(to bottom,  #00a0c1 0%,#00a0c1 50px,#ffffff 50px); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
 }

 .pagination > li > a
  {
    background-color: white;
    color: #00a0c1;
  }

 .pagination > li > span
  {
    background-color: white;
    color: #00a0c1;
  }
 .pagination > li > span:hover
  {
    background-color: white;
    color: #00a0c1;
  }

  .text-stroke{
    text-shadow: 0 0 2px #00a0c1; /* horizontal-offset vertical-offset 'blur' colour */
    -moz-text-shadow: 0 0 2px #00a0c1;
    -webkit-text-shadow: 0 0 2px #00a0c1;
  }


 </style>